import { IImage } from '@utils/contentful/contentfulImage'
import { ContentfulService } from './contentful'
import { ISharedPageData } from '@utils/contentful/getSharedPageData/getSharedPageData'
import { EditorContentfulConfiguration } from 'app/(main)/(catalog)/upload/[slug]/_components/designUpload/types'
import { CategoryPage } from 'types/contentful/categoryPage'
import { IPlusEditorContentfulConfiguration } from 'app/(main)/(catalog)/quote/[slug]/_types'
import { ICartSidebar } from 'types/contentful/cartSidebar'
import { Entry } from 'contentful'

export interface IPageDataService {
  getAccountManagerPicture: (email: string) => Promise<IImage>
  getProductEntries: ({
    urlSlug,
    productSlug,
  }: {
    urlSlug: string
    productSlug?: string
  }) => Promise<any>
  getPageComponents: ({
    pageSlug,
    dataForParsers,
  }: {
    pageSlug: string
    dataForParsers: any
  }) => Promise<any>
  getSharedPageData: () => Promise<ISharedPageData>
  getShardedSharedPageData: () => Promise<any>
  getEntriesWithFetch: ({
    contentType,
    query,
    include,
  }: {
    contentType: string
    query: string
    include: number
  }) => Promise<{ items: { fields: any }[] | undefined }>
  getEditorConfiguration: ({
    slug,
  }: {
    slug: string
  }) => Promise<EditorContentfulConfiguration | null>
  getCategoryPageData: ({
    slug,
  }: {
    slug: string
  }) => Promise<CategoryPage | null>
  loadPlusEditorConfig: ({
    slug,
  }: {
    slug: string
  }) => Promise<IPlusEditorContentfulConfiguration | null>
  getCartSidebar: () => Promise<ICartSidebar>
  getCrossSellOverride: (slug: string) => Promise<any>
}
export class PageDataServiceFactory {
  static createService(
    type: 'contentful' | string = 'contentful'
  ): IPageDataService {
    switch (type) {
      case 'contentful':
        return new ContentfulService()
      // For future CMS implementations
      // case 'prismic':
      //   return new PrismicService()
      default:
        // Default to contentful for now
        return new ContentfulService()
    }
  }
}
